import { Box } from "@mui/material";
import TkStepper from "../../components/atoms/TkStepper";
import {
  contextText,
  headList,
  searchFormList,
  searchFormSchema,
  steps,
} from "./parts";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkDataTable from "../../components/molecules/TkDataTable";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { httpIAPI_FAC033 } from "./api/request";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { FacilityKind } from "../../assets/data/Constants";
import TkSearchForm from "../../components/molecules/TkSearchForm";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkButton from "../../components/atoms/TkButton";
import "./_style.scss";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { IAPI_FAC033_Response } from "../../type/apiType";
import { FacilityList } from "../../type/apiType/IAPI_FAC033";
import { TkRouteContext } from "../../context/tkRouteContext";
import _ from "lodash";

/**
 * SCRC050120 廃止・休止・経営移管施設選択
 * 廃止対象の施設ごとの許認可書を添付する。
 * @return SCRC050120
 */
const SCRC050120 = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const context = businessState.job_18;
  const [stateSearchList, setStateSearchList] = useState<any>();
  const searchList = useRef(_.cloneDeep(searchFormList));
  const [bodyList, setBodyList] = useState<any>([]);
  const [selectedFacilities, setSelectedFacilities] = useState<any>([]);
  const [isNextDialogOpen, setIsNextDialogOpen] = useState(false);
  const [resData, setResData] = useState<IAPI_FAC033_Response>({
    resultCd: "",
    facilityList: [],
  });
  const checkedList = useRef<number[]>([]);
  const isKiko =
    state.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const { state: routerState, setState: setRouterState } =
    useContext(TkRouteContext);
  const wantToSetInRouterList = useRef<any>(
    location.state?.wantToSetInRouterList ?? []
  );

  useEffect(() => {
    if (wantToSetInRouterList.current.length === 0) return;
    if (_.isEqual(wantToSetInRouterList.current, routerState.routerList))
      return;
    setRouterState({
      routerList: wantToSetInRouterList.current as any,
    });
  }, [wantToSetInRouterList, routerState.routerList, setRouterState]);

  const handleRefer = async (data?: any) => {
    // 廃止・休止・経営移管施設選択表示API実行
    try {
      const res = await httpIAPI_FAC033({
        contractorNo: isKiko
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        ...data,
      });

      if (res.resultCd === "I0000") {
        setResData(res);
        let checked: any[] = [];
        let bodyList = res.facilityList?.map((item: any, index: number) => {
          if (item.processStatus === "一時保存中") {
            checked.push(index);
          }
          return [
            {
              keyword: item.facilityName,
              children: `${item.facilityNo}:${item.facilityName}`,
              forSort: item.facilityNo,
              disabledCheckBox:
                item.processStatus === "申請中" ||
                item.processStatus === "一時保存中",
            },
            {
              keyword: item.facilityKind,
              children:
                FacilityKind[item.facilityKind as keyof typeof FacilityKind],
            },
            {
              children: item.processStatus,
            },
            {
              children: item.joinStaffNum,
              forSort: item.joinStaffNum,
            },
          ];
        });
        checkedList.current = checked;
        setBodyList(bodyList);

        setBusinessState({
          ...businessState,
          job_18: {
            ...context,
            facilityList: [],
            ...data,
          },
        });

        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    let resArr = searchList.current;
    for (let i in context) {
      let targetObj = resArr.find((item: any) => item.keyword === i)!;

      targetObj &&
        (targetObj.wantToSetValue = context[i as keyof typeof context]);
    }
    setStateSearchList([...resArr]);

    handleRefer({
      facilityKind: context?.facilityKind,
      facilityName: context?.facilityName,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleNext = () => {
    if (selectedFacilities.length === 0) {
      setState({
        ...state,
        errorMsgId: "TKMSG_SCR0044E",
      });
      return;
    }
    // 施設情報リストの施設区分が"1"(社会福祉施設等)、"3"(特定介護保険施設等)の施設が全て選択されている場合
    const allMatchingFacilities = resData.facilityList?.filter(
      (facility: FacilityList) =>
        facility.facilityKbn === "1" || facility.facilityKbn === "3"
    );
    const allSelectedFacilities = selectedFacilities.filter(
      (facility: FacilityList) =>
        facility.facilityKbn === "1" || facility.facilityKbn === "3"
    );

    if (
      allMatchingFacilities?.length === allSelectedFacilities.length &&
      allSelectedFacilities.length > 0
    ) {
      setIsNextDialogOpen(true);
    } else {
      let sortedList = selectedFacilities?.sort?.(
        (a: any, b: any) =>
          Number.parseInt(a?.facilityNo || 0) -
          Number.parseInt(b?.facilityNo || 0)
      );
      setBusinessState({
        ...businessState,
        job_18: {
          ...context,
          applyId: resData.applyId,
          facilityList: sortedList,
        },
      });
      setState({
        ...state,
        errorMsgId: "",
      });
      navigate("/SCRC050121");
    }
  };

  const handleCheckSectionWidth = (selectedIndexes: number[]) => {
    if (resData.facilityList) {
      const selectedFacilities = selectedIndexes.map(
        (index) => resData.facilityList![index]
      );
      setSelectedFacilities(selectedFacilities);
    }
  };

  const handleOkey = () => {
    setBusinessState({
      ...businessState,
      common: {
        ...(businessState.common || {}),
        businessType: "JOB-02",
      },
    });
    navigate("/SCRC050106");
  };

  return (
    <Box className="SCRC050120" data-testid="SCRC050120Test">
      <TkStepper steps={steps} />

      <TkInfoManual>{labelids.labelid.LBLC050120_01}</TkInfoManual>

      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo}:${businessState.common?.contractorName}`}
        />
      )}

      <TkSearchForm
        listData={stateSearchList}
        ruleSchema={searchFormSchema}
        onSearch={handleRefer}
      />

      <TkDataTable
        headList={headList}
        bodyList={bodyList}
        checkSection={true}
        onCheckSectionWidth={handleCheckSectionWidth}
        wantToCheck={checkedList.current}
      />

      <Box className="button">
        <TkBackButton />
        <TkButton onClick={handleNext}>次へ</TkButton>
      </Box>
      <Box>
        <TkMessageDialog
          data-testid="TkMessageDialog"
          open={isNextDialogOpen}
          onOky={handleOkey}
          onCancel={() => {
            setIsNextDialogOpen(false);
          }}
          title="確認（機構へ提出する）"
          children={<TkInfoManual rule={"<"}>{contextText}</TkInfoManual>}
          cancelText="戻る"
          okText="確認"
        />
      </Box>
    </Box>
  );
};

export default SCRC050120;
